import { FC } from "react";

import { SVG_MUI } from "@ryde/assets";
import { useApplication, useSimpleNavigation } from "@ryde/redux";
import { useDebugMode } from "@ryde/shared";

import { LeftBarBottom } from "./left-bar.bottom";
import { LeftBarNavigation } from "./left-bar.navigation";
import { LeftBarNavigationAdmin } from "./left-bar.navigation.admin";
import { LeftBarStyled, LogoBoxStyled } from "./parts";

export const LeftBar: FC = () => {
  const { navigateHome } = useSimpleNavigation();
  const { isAdminApp } = useApplication();
  const { isNonProductionNavbarColor } = useDebugMode();

  return (
    <LeftBarStyled
      $isAdminApp={isAdminApp}
      $isNonProduction={isNonProductionNavbarColor}
    >
      <LogoBoxStyled
        type="button"
        aria-label="Go to home"
        onClick={navigateHome}
        className="logo_box"
      >
        <SVG_MUI.LogoLeftSVG data-e2e="svg-ryde-logo" aria-hidden="true" />
      </LogoBoxStyled>
      {isAdminApp ? <LeftBarNavigationAdmin /> : <LeftBarNavigation />}
      <LeftBarBottom />
    </LeftBarStyled>
  );
};
